<template>
    <div class="focus-section" id="focus">
        <v-row id="focus" style="background-color:white;min-height:100vh">
            <v-col cols="1"></v-col>
            <v-col cols="10">
                <v-row>
                    <v-col cols="12">
                        <h2 style="text-align:right" class="header-watermark">focus</h2>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="4" class="info-col-padding-2">
                        <KinesisContainer>

                            <KinesisElement tag="img" src="/img/accesscontrol.png" :strength="isMobile() ? 0 : 20"
                                style="width:50%;margin-left:0px" type="depth" />

                            <KinesisElement tag="h3" type="depth" :strength="isMobile() ? 0 : 20"
                                style="margin-top:0px;color:#a6a6a6">Contactless Access Control</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : 30" style="margin-top:0px;color:#111111">
                                The recent pandemic has highlighted the need for contact-less access control. We are
                                actively developing access control sensors in fit for purpose form factors</KinesisElement>

                        </KinesisContainer>
                    </v-col>

                    <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="4" class="info-col-padding-2">
                        <KinesisContainer>

                            <KinesisElement tag="img" src="/img/mobile.png" :strength="isMobile() ? 0 : 20"
                                style="width:50%;margin-left:0px" type="depth" />

                            <KinesisElement tag="h3" type="depth" :strength="isMobile() ? 0 : 20"
                                style="margin-top:0px;color:#a6a6a6">The Mobile, Web, IOT Nexus</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : 30" style="margin-top:0px;color:#111111">We
                                are constantly exploring ways in which mobile devices can interact with IOT device through
                                the web and other near field communications</KinesisElement>

                        </KinesisContainer>
                    </v-col>

                    <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="4" class="info-col-padding-2">
                        <KinesisContainer>

                            <KinesisElement tag="img" src="/img/monitor.png" :strength="isMobile() ? 0 : 20"
                                style="width:50%;margin-left:0px" type="depth" />

                            <KinesisElement tag="h3" type="depth" :strength="isMobile() ? 0 : 20"
                                style="margin-top:0px;color:#a6a6a6">Remote Configuration and Monitoring</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : 30" style="margin-top:0px;color:#111111">
                                Monitoring and configuring deployments is key and we have a focus on creating Web
                                administration tools and simple to use API's</KinesisElement>

                        </KinesisContainer>
                    </v-col>

                    <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="4" class="info-col-padding-2">
                        <KinesisContainer>

                            <KinesisElement tag="img" src="/img/secure.png" :strength="isMobile() ? 0 : 20"
                                style="width:50%;margin-left:0px" type="depth" />

                            <KinesisElement tag="h3" type="depth" :strength="isMobile() ? 0 : 20"
                                style="margin-top:0px;color:#a6a6a6">Secure Protocols</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : 30" style="margin-top:0px;color:#111111">We
                                are actively developing simple security protocols to protect privacy and secure
                                communications amongst IOT devices</KinesisElement>

                        </KinesisContainer>
                    </v-col>

                    <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="4" class="info-col-padding-2">
                        <KinesisContainer>

                            <KinesisElement tag="img" src="/img/ai.png" :strength="isMobile() ? 0 : 20"
                                style="width:50%;margin-left:0px" type="depth" />

                            <KinesisElement tag="h3" type="depth" :strength="isMobile() ? 0 : 20"
                                style="margin-top:0px;color:#a6a6a6">Machine Learning</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : 30" style="margin-top:0px;color:#111111">We
                                are researching and building prototypes of applications of computer vision in the areas of
                                facial recognition, ALPR and generalised object detection on AI Edge runtimes
                            </KinesisElement>

                        </KinesisContainer>
                    </v-col>

                </v-row>
            </v-col>
            <v-col cols="1"></v-col>
        </v-row>
    </div>
</template>

<script>
import { KinesisContainer, KinesisElement } from 'vue-kinesis'

export default {
    components: {
        KinesisContainer,
        KinesisElement
    },
    data: () => ({
        carouselItem: 0,
        selectedPortfolio: null,
        showDialog: false,
        portfolio: [
            {
                files: [
                    '/img/easefica-1.png',
                    '/img/easefica-2.png',
                    '/img/easefica-3.png',
                    '/img/easefica-4.png',
                ]
            },
            {
                files: [
                    '/img/easefica-admin-1.png',
                    '/img/easefica-admin-2.png',
                    '/img/easefica-admin-3.png',
                    '/img/easefica-admin-4.png',
                ]
            },
            {
                files: [
                    '/img/loomiot-1.png',
                    '/img/loomiot-2.png',
                    '/img/loomiot-3.png',
                ]
            }
        ]
    }),
    methods: {
        isMobile() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        selectPortfolio(p) {
            this.selectedPortfolio = p;
            this.carouselItem = 0;
            this.showDialog = true;
        },
        closePortfolio() {
            this.selectedPortfolio = null;
            this.carouselItem = 0;
            this.showDialog = false
        }
    }
}
</script>

<style scoped>
.watermark-black {
    font-size: 256px;
    font-family: "Walkway Black";
    font-weight: lighter;
    line-height: 280px;
    margin-top: 32px;
    color: rgba(255, 255, 255, 0.05);
    max-width: 100%;
    overflow: hidden;
}

.header-watermark {
    font-size: 256px;
    font-family: "Walkway Black";
    font-weight: lighter;
    line-height: 280px;
    overflow: hidden;
    color: rgba(0, 0, 0, 0.05);
    margin-bottom: -100px;
    margin-top: 32px;
}

.carousel-view {
    height: 80vh;
    width: 80vw;
    border-radius: 5px;
    z-index: 100;
}

.close-button {

    background-color: white;
}

.portfolio-list {
    margin-top: 32px;
}

.portfolio-item {
    position: relative;
    margin-top: 120px;
    min-height: 50vh;
    cursor: pointer;
}

.web-section {
    position: relative;
    background-color: #111111;
    min-height: 100vh;
    width: auto;
    background: url('/img/bg2.jpg');
    background-size: cover
}

.web-heading {
    position: absolute;
    width: 100%;
    top: 0%
}

@media (max-width: 1020px) {
    .portfolio-item {
        position: relative;
        margin-top: 120px;
        min-height: 40vh;
        cursor: pointer;
    }
}

@media (max-width: 600px) {
    .portfolio-item {
        position: relative;
        margin-top: 32px;
        min-height: 25vh;
        cursor: pointer;
    }
}

@media (max-width: 1020px) {
    .portfolio-item {
        position: relative;
        margin-top: 120px;
        min-height: 40vh;
        cursor: pointer;
    }

    .header-watermark {
        font-size: 200px;
        font-family: "Walkway Black";
        font-weight: lighter;
        line-height: 280px;
        overflow: hidden;
        color: rgba(0, 0, 0, 0.05);
        margin-bottom: -100px;
        margin-top: 0px;
    }

    h3 {
        font-family: "Walkway Black", Helvetica, Arial;
        font-size: 32px;
        font-weight: lighter;
        line-height: 40px;
    }

    h4 {

        font-size: 20px;
        font-weight: lighter;
        line-height: 28px;
        margin-top: 8px;
        margin-bottom: 16px;
    }
}

@media (max-width: 600px) {
    .portfolio-item {
        position: relative;
        margin-top: 32px;
        min-height: 25vh;
        cursor: pointer;
    }

    .header-watermark {
        font-size: 128px;
        font-family: "Walkway Black";
        font-weight: lighter;
        line-height: 280px;
        overflow: hidden;
        color: rgba(0, 0, 0, 0.05);
        margin-bottom: -100px;
        margin-top: 0px;
    }

    h3 {
        font-family: "Walkway Black", Helvetica, Arial;
        font-size: 32px;
        font-weight: lighter;
        line-height: 40px;
    }

    h4 {

        font-size: 20px;
        font-weight: lighter;
        line-height: 28px;
        margin-top: 8px;
        margin-bottom: 16px;
    }
}
</style>